import * as React from 'react';
import { SubmissionsProps } from './Submissions';
import { SubmissionState } from '../interface/SubmissionInterface';
import Select from 'react-select';

export default class EmpItemContent extends React.Component<SubmissionsProps, SubmissionState>{
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: this.props.bodyItem.epss_classification,
            isChecked: false
        };
    }
    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
        //post data to db
    }
    onCheckChange = () => {
        this.setState({ isChecked: !this.state.isChecked });
    }
    componentDidUpdate(prevProps) {
        if (this.props.selectedOptionAll != prevProps.selectedOptionAll) {
            this.setState({ selectedOption: this.props.selectedOptionAll });
        }
    }
    public render() {

        const options = [
            { value: 'undergraduate', label: 'Undergraduate' },
            { value: 'graduate student', label: 'Graduate Student' },
            { value: 'post graduate research', label: 'Post Graduate Research' },
            { value: 'faculty', label: 'Faculty' },
            { value: 'other student', label: 'Other Student' },
            { value: 'staff', label: 'Staff' },
        ];

        return <tr className="rowContent">
            <td><input
                checked={this.props.checkAll ? this.props.checkAll : this.state.isChecked}
                type="checkbox"
                onChange={this.onCheckChange}
            />&nbsp;&nbsp;{this.props.bodyItem.job_title}</td><td>Graduate Student</td><td>{this.props.bodyItem.object_code_desc}</td><td>Y</td>
            <td><Select
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={options}
            /></td><td><span>{this.props.bodyItem.last_updated_date}</span><span>{this.props.bodyItem.last_updated_by}</span></td><td></td></tr>;
    }
}

//return <tr><td>{bodyItem.job_title}</td><td>{bodyItem.occupational_class}</td><td>{bodyItem.object_code}</td><td>{bodyItem.cfda_flag}</td><td>{bodyItem.epss_classification}</td><td><span>{bodyItem.last_updated_date}</span><span>{bodyItem.last_updated_by}</span></td></tr>
